import script from "./CategoriesSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./CategoriesSection.vue?vue&type=script&setup=true&lang=ts"

import "./CategoriesSection.vue?vue&type=style&index=0&id=b0164d96&lang=scss"

const __exports__ = script;

export default __exports__